export const statusBulletStates = {
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  // NOT_STARTED: 'not_started',
  SUCCESS: 'COMPLETED',
  UNKNOWN: 'UNKNOWN',
};
